import { default as MenuMUI } from '@material-ui/core/Menu';
import { default as MenuItemMUI } from '@material-ui/core/MenuItem';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização da nav
 */
export default styled.nav`
  display: inline-block;

  button {
    background: none;
    border: none;
    padding: 14px 11px 9px 11px;

    svg {
      path {
        fill: rgba(255, 255, 255, 0.8);
      }
    }
  }
`;

/**
 * Estilização do componente Menu
 */
export const Menu = styled(MenuMUI)`
  .MuiPaper-root {
    border-radius: 3px;
    width: auto;
    max-width: 280px;
    overflow-x: initial;
    overflow-y: initial;
    padding-left: 29;
    top: 47px;
    
    .arrow {
      position: absolute;
      top: -12px;
      left: 147px;
      border-left: 11px solid transparent;
      border-right: 11px solid transparent;
      border-top: none;
      border-bottom: 12px solid white;
    }

    h1 {
      font-weight: 300;
      font-size: 16px;
      line-height: 19px;
      color: #5e6366;
      margin: 12px;
    }

    hr {
      margin: 12px 27px 12px 0;
      border-top: 1px solid #e6e6e6;
    }

    .items {
      max-height: 260px;
      overflow-y: scroll;
      overflow-x: hidden;
      display: block;
    }
  }
`;

/**
 * Estilização do componente MenuItem
 */
export const MenuItem = styled(MenuItemMUI)`
  white-space: normal;
  padding: 0;
  width: calc(100% - 12px);
  margin-bottom: 15;
  display: block;

  &:hover {
    background: rgba(96, 52, 190, 0.08);

    .desc-bt {
      opacity: 1;
    }
  }

  > div {
    &:hover {
      text-decoration: none;
    }

    > div {
      display: flex;
      flex-direction: row;
      align-items: center;

      > img {
        flex: 0 0 auto;
        width: 36px;
        height: 36px;
        margin-right: 8px;
        border-radius: 3px;
      }

      h4 {
        color: rgba(0, 0, 0, 0.6);
        width: 180px;
        font-size: 12px;
        line-height: 14px;
        text-transform: uppercase;
        margin-bottom: 1px;
        transform: translateY(-2px);
      }

      .desc-bt {
        opacity: 0;
        padding: 0;
        border: none;
        background: transparent;
        margin-right: 12px;
        color: #5e5e5e;
        transition: opacity 300ms;

        &:hover {
          color: #3c71dd;
        }
      }
    }

    .description {
      max-height: 0;
      padding: 0;
      opacity: 0;
      transition: max-height 300ms, opacity 100ms;
      overflow: hidden;

      &.expanded {
        padding: 12px 13px 8px 15px;
        max-height: 100px;
        opacity: 1;
        transition: max-height 300ms, opacity 600ms;
      }

      p {
        margin: 0;
        word-break: break-word;
        white-space: normal;
        font-size: 11px;
        line-height: 12px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        color: #5e5e5e;
      }
    }
  }
`;
